import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var attendanceHistoryListRes;
export const attendanceHistoryListTodo = createAsyncThunk('attendanceHistoryList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/attendence_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "vemp_companycode": user_id.vemp_companycode,
                "imonth": data.month,
                "vfin_year_name": data.fy,
                "ibusiness_area_id": user_id.ibusiness_area_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return attendanceHistoryListRes = res.data
    } catch (error) {
        return attendanceHistoryListRes = error.response.data
    }
})


const attendanceHistoryListSlice = createSlice({
    name: 'attendanceHistoryList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(attendanceHistoryListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('attendanceHistoryList', state.data)
            }
        });
        builder.addCase(attendanceHistoryListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default attendanceHistoryListSlice.reducer; 